import { render, staticRenderFns } from "./EstimatedTurnover.vue?vue&type=template&id=a361fda2&scoped=true&"
import script from "./EstimatedTurnover.vue?vue&type=script&lang=js&"
export * from "./EstimatedTurnover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a361fda2",
  null
  
)

export default component.exports